import { Live2State } from "./live-2-types";

const initialState: Live2State = {
  companies: [],
};

export default function live2Reducer(state = initialState, { type, payload }) {
  switch (type) {
    case "SET_COMPANIES": {
      return { ...state, companies: [...payload.companies] };
    }
    default:
      return state;
  }
}
